import { ArrowForwardRounded, LabelImportantRounded } from '@mui/icons-material'
import { Box, CardActions, CardContent, CardMedia, Tooltip, Typography } from '@mui/material'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import relativeTime from 'dayjs/plugin/relativeTime'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router'
//import * as VipStyles from '../../contexts/shared/styles/VipStyles'
import { setFavorite, unsetFavorite } from '../../../../../redux/actions/favorites'
import TooltipCards from '../../../../shared/components/TooltipCards'
import FavoriteButton from '../../../../shared/components/buttons/FavoriteButton'
import ShareIcon from '../../../../shared/components/icons/ShareIcon'
import useGeneralSummaryReport from '../../../../shared/hooks/useGeneralSummaryReport'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { CardItem, ContentPrimary, ImgPrimary, LinkPrimary } from '../../../../shared/styles/SeminarGlobalStyles'
import { SeminarCardProps } from '../../models/seminar'

dayjs.locale('es')
dayjs.extend(relativeTime)

function SeminarCard({ seminar, type }: SeminarCardProps) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { handleClickGeneralSummaryReport } = useGeneralSummaryReport(8)

  const handleFavoriteClick = (seminar_id: number) => (state: boolean) => {
    handleClickGeneralSummaryReport(seminar_id)
    if (state) {
      dispatch(setFavorite({ id: seminar_id, state, type: 'seminar' }))
    } else {
      dispatch(unsetFavorite({ id: seminar_id, state, type: 'seminar' }))
    }
  }

  const handleClickCard = () => {
    handleClickGeneralSummaryReport(seminar.id)
    navigate(`/seminarios/${seminar.id}`)
  }

  // let inLive = null
  // let vip = null

  return (
    <>
      {type === 0 ? (
        <ImgPrimary
          position="relative"
          overflow="hidden"
          style={{ backgroundImage: `url(${`${import.meta.env.VITE_AWS_URL}/seminars/${seminar.cover}`})` }}
        >
          <Tooltip title={seminar.title} arrow>
            <ContentPrimary onClick={() => handleClickCard()}>
              <Box display="flex" gap={16} alignItems="center">
                <Typography variant="h4" align="left">
                  {seminar.title}
                </Typography>
                {/*{inLive && <LabelLive icon={<FiberManualRecord fontSize="small" />} label="En vivo" />}*/}
              </Box>
              {seminar.datetime !== null && (
                <Typography>{`${dayjs(seminar.datetime).format('dddd, D [de] MMMM [de] YYYY HH:mm')}`}</Typography>
              )}
              <LinkPrimary variant="text" endIcon={<ArrowForwardRounded />}>
                <Typography>{t('more-info')}</Typography>
              </LinkPrimary>
            </ContentPrimary>
          </Tooltip>
          {/*{vip === true && (*/}
          {/*  <VipStyles.VipSlider position="absolute">*/}
          {/*    <Typography>VIP</Typography>*/}
          {/*  </VipStyles.VipSlider>*/}
          {/*)}*/}
        </ImgPrimary>
      ) : (
        <>
          <CardItem>
            <>
              <CardMedia
                image={`${`${import.meta.env.VITE_AWS_URL}/seminars/${seminar.cover}`}`}
                component="img"
                alt={seminar.title}
                height="130"
                onClick={() => {
                  navigate(`/seminarios/${seminar.id}`)
                }}
              />

              <CardContent style={{ padding: 8, paddingBottom: 0 }}>
                <Box
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    navigate(`/seminarios/${seminar.id}`)
                  }}
                >
                  <TooltipCards titleCard={seminar.title} classNameCustom="resourceTitle" />
                  {seminar.title === null && (
                    <Box minHeight="19.5px">
                      <Box display="flex" alignItems="center" gap={4}>
                        <LabelImportantRounded fontSize="small" htmlColor="#8F99A3" />
                        <Typography variant="body2" color="textSecondary">
                          P&Q
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Box>
              </CardContent>
              <CardActions
                style={
                  isMobile
                    ? { padding: '0px 6px 0px 0px', justifyContent: 'space-between' }
                    : { padding: '0px 12px', justifyContent: 'space-between' }
                }
                disableSpacing
              >
                <Box display="flex" pl={isMobile ? '6px' : undefined}>
                  <FavoriteButton handleClick={handleFavoriteClick(seminar.id)} favoriteState={Boolean(seminar.favoriteId)} />
                  <ShareIcon
                    visibility={seminar.visibility}
                    title={seminar.title}
                    description={seminar.description}
                    link={`${window.location.origin}/seminarios/${seminar.id}${window.location.search}`}
                    multimedia={seminar.cover === null ? '' : seminar.cover}
                    type="eventLive"
                    multimediaType={'image'}
                    buttonText={t('share')}
                  />
                </Box>
                <Box
                  width="max-width"
                  height="48px"
                  display="flex"
                  alignItems="center"
                  pr={isMobile ? 2 : 1}
                  onClick={() => {
                    navigate(`/seminarios/${seminar.id}`)
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  {seminar.datetime !== null && (
                    <Typography variant="body2" color="textSecondary">{`${dayjs(seminar.datetime).endOf('hour').fromNow()}`}</Typography>
                  )}
                </Box>
              </CardActions>
            </>
            {/*{vip === true && (*/}
            {/*  <VipStyles.VipSlider position="absolute">*/}
            {/*    <Typography>VIP</Typography>*/}
            {/*  </VipStyles.VipSlider>*/}
            {/*)}*/}
            {/*{inLive && (*/}
            {/*  <Box position="absolute" top={24} right={vip === true ? 80 : 16}>*/}
            {/*    <LabelLive icon={<FiberManualRecord fontSize="small" />} label="En vivo" />*/}
            {/*  </Box>*/}
            {/*)}*/}
          </CardItem>
        </>
      )}
    </>
  )
}

export default SeminarCard
